(function() { // porovnani
    var $porovnani, $id, $bottom, active;

    function probliknoutNastaveni(klasa)
    {
        var pocetProbliknuti = 1;
        var blikani = function () {
            $('.porovnani-head').toggleClass('add-porovnani');
        };
        for (var i = 0; i < (pocetProbliknuti * 2); i++) {
            setTimeout(blikani, (600 * i));
        }
    }

    function addToPorovnani($porovnani)
    {
        $id = $porovnani.attr('id').replace('p-', '');
        if ($porovnani.hasClass('active')) {
            active = false;
            $porovnani.removeClass('active');
            if ($porovnani.html() != '') {
                $porovnani.html((locale.locale == 'cs' ? "<span>Porovnat</span>" : '<span>Compare</span>'));
            }
        } else {
            active = true;
            $porovnani.addClass('active');
            if ($porovnani.html() != '') {
                $porovnani.html((locale.locale == 'cs' ? "<span>Odebrat</span>" : '<span>Remove</span>'))
            }
        }

        $.ajax({
            'url': locale.url_parovani+'?id=' + $id + '&ajax=1&=' + new Date().getTime(),
            'type': 'GET',
            'data': '',
            'success': function(data, status, xhr) {
                if ($('.js-porovnani-list').length !== 0) {
                    window.location.reload();
                } else {
                    $bottom = $('.JS-porovnani-bottom');
                    $('.js-porovnani-link').show();
                    $('.js-porovnani-link .count').text(data);
                    $bottom.html(data);
                    $bottom.show();
                }
                probliknoutNastaveni();
            }
        });
    }

    $('body').delegate('.js-porovnani', 'click', function(ev) {
        addToPorovnani($(this));
    });

    // Navigace
    var $navigace, $next, $prev, $first, $hide, $active;
    $navigace = $('.navigace');
    if ($navigace.length === 0)
        return;

    $next = $navigace.find('.next');
    $prev = $navigace.find('.prev');

    $next.bind('click', function() {
        $prev.show();
        $('tr').each(function(i, tr) {
            $active = $(tr).find('td.active:first');
            $hide = $(tr).find('td.active:last').next();

            $active.removeClass('active').addClass('hide');
            $hide.removeClass('hide').addClass('active');

            $hide = $(tr).find('td.active:last').next();
            if ($active.length > 0 && $hide.length === 0)
                $next.hide();
        });
    });

    $prev.bind('click', function() {
        $next.show();
        $('tr').each(function(i, tr) {
            $active = $(tr).find('td.active:last');
            $hide = $(tr).find('td.active:first').prev();

            $active.removeClass('active').addClass('hide');
            $hide.removeClass('hide').addClass('active');

            $hide = $(tr).find('td.active:first').prev('.hide');
            if ($active.length > 0 && $hide.length === 0)
                $prev.hide();
        });
    });
}());